'use client';

import { BKGROUND_IMAGE, BKGROUND_IMAGE_BOOKSHELF, isBookshelfSubdomain } from '@/constants/general';
import { useSearchParams } from 'next/navigation';

const Page = () => {
    const backgroundImage = `url(${BKGROUND_IMAGE})`;
    const backgroundImageBookSelf = `url(${BKGROUND_IMAGE_BOOKSHELF})`;

    // Get the client's IP address from the request headers
    // const ip = headers().get('x-forwarded-for');
    // console.log(headers());

    const searchParams = useSearchParams(); // Add this line
    const paramkey = isBookshelfSubdomain();

    return (
        <>
            {/* <p>
                IP Address:
                {` ${ip}` || ' Not found'}
            </p> */}
            <div
                className="relative flex flex-col items-center justify-center bg-cover bg-no-repeat"
                style={{
                    backgroundImage: paramkey ? backgroundImageBookSelf : backgroundImage,
                    minHeight: '90vh',
                }}
            ></div>
        </>
    );
};

export default Page;
